/**
 * Estimaciones
 *
 */
import React from 'react'
import { Input, Divider } from 'antd'
import { Page, Panel } from '../../../components'
import Api from '../../../Api'
import Exception from '../../../Exception'
import { connect } from 'react-redux'
import { Actividad } from './Components/Actividad'
import { HistorialAvancesActividad } from './Components/Historial'
import { AvanceForm } from './Components/AvanceForm'
// import _ from 'lodash'

class AvancesPage extends React.Component {
  /**
   * Constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      inicio: -1,
      termino: -1,
      search: '',
      actividades: [],
      avances: [],
      lookup: [],

      actividadId: null,
      avanceId: null,
    }

    this.solicitarPago = null
  }

  /**
   * Invocado cuando el componente es montado
   */
  componentDidMount() {
    this.fetchActividades()
  }

  /**
   * actualizarFila
   *
   * @param {number} id
   */
  actualizarFila = (id) => {
    Api.query({
      __returnType: 'one',
      model: 'CmrConceptoAnexo',
      attributes: [
        'id',
        'actividad',
        'descripcion',
        'cantidad',
        'volumenAvance',
        'porcentajeAvance',
        'medida',
        'inicio',
        'termino',
        ['pu_mxn', 'precio'],
      ],

      where: { id },
    })
    .then(response => {
      this.setState((prev) =>
        ({
          actividades: prev.actividades.map(
            (item) => item.id !== id ? item : ({
              ...item,
              ...response.data,
            })
          )
        })
      )
    })
    .catch(error => {
      this.setState({ loading: false })
      Exception.load(error).show()
    })
  }

  /**
   * Cargar
   */
  fetchActividades = async (busqueda = '') => {
    try {
      const proyecto = this.props.match.params.codigo
      this.setState({ loading: true })

      const { data: escalatoria } = await Api.query({
        __returnType: 'one',
        attributes: ['id'],
        model: 'ComEscalatoria',
        include: [{
          as: 'proyecto',
          required: true,
          attributes: [],
          where: {
            sContrato: proyecto,
            iActivo: true,
          },
        }],
        where: {
          activo: true,
        },
        order: [['id', 'DESC']],
      })

      if (!escalatoria) {
        this.setState({ loading: false })
        return
      }

      const like = { $like : `%${busqueda}%` }
      const filter = busqueda.length === 0 ? null : {
        $or: [
          { actividad: like },
          { descripcion: like },
          { medida: like },
        ]
      }

      const { data: partidas } = await Api.query({
        model: 'CmrConceptoAnexo',
        attributes: [
          'id',
          'actividad',
          'descripcion',
          'cantidad',
          'volumenAvance',
          'porcentajeAvance',
          'medida',
          'inicio',
          'termino',
          ['pu_mxn', 'precio'],
        ],

        where: {
          escalatoria: escalatoria.id,
          activo: true,
          $and: [
            { $whereFn: ['length', ['$medida$'], { $gt: 0 }] },
          ],
          ...filter,
        },
        order: [
          ['volumenAvance', 'desc'],
          ['wbs', 'asc'],
        ]
      })

      const actividadActualId = this.state.actividadId
      const actividadId = partidas.length && partidas.findIndex(a => a.id === actividadActualId) > -1 ? actividadActualId : (
        partidas.length ? partidas[0].id : null
      )

      this.setState({
        actividades: partidas,
        actividadId: actividadId,
        loading: false,
        search: busqueda,
      })
    } catch (error) {
      this.setState({
        actividades: [],
        loading: false,
      })
      Exception.load(error).show()
    }
  }

  /**
   * Actividades
   *
   */
  actividades = () => {
    return (
      <div style={{ ...styles.seccion.root, width: 300 }}>
        <div style={styles.sections.header}>
          <h2 style={{ marginBottom: 20 }}>Actividades</h2>
          <Input.Search
            allowClear
            placeholder='Buscar'
            onSearch={text => this.fetchActividades(text)}
          />
        </div>

        <Divider className='unmargin' />

        <div style={styles.seccion.wrapper}>
          <div style={styles.seccion.content}>
            {this.state.actividades.map((actividad, idx, arr) =>
              <div key={actividad.id.toString()} style={{ ...styles.actividad.normal, borderLeftColor: actividad.id === this.state.actividadId ? this.props.theme.colors.accent : 'transparent' }}>
                <Actividad
                  {...actividad}
                  avanceCompletado={idx % 2}
                  cobroCompletado={idx % 2 && idx % 3 === 0}
                  onClick={() => this.setState({ actividadId: actividad.id, })}
                />

                {idx < arr.length - 1 ? (<Divider className='unmargin' />) : null}
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }

  /**
   * Avances
   *
   */
  avances = () => {
    return (
      <div style={{ ...styles.seccion.root, flex: 1 }}>
        <div style={styles.sections.header}>
          <h2 style={{ marginBottom: 20 }}>Avances</h2>
          <AvanceForm
            actividadId={this.state.actividadId}
            onReload={() => this.historial.fetch(this.state.actividadId)}
            onCancel={() => this.setState({ avanceId: null })}
            onSave={() => {
              this.historial.fetch(this.state.actividadId)
              this.actualizarFila(this.state.actividadId)
            }}
          />
        </div>

        <div style={styles.seccion.wrapper}>
          <div style={{ ...styles.seccion.content, width: '100%' }}>
            <div style={styles.avances.root}>
              <HistorialAvancesActividad
                ref={ref => this.historial=ref}
                actividadId={this.state.actividadId}
                editingAvanceId={this.state.avanceId}
                onEdit={id => this.setState({ avanceId: id })}
                onRemove={() => this.actualizarFila(this.state.actividadId) }
                onSave={() => this.actualizarFila(this.state.actividadId) }
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  /**
   * Render
   */
  render() {
    return (
      <Page>
        <div style={styles.root}>
          <Panel style={styles.panel}>
            {this.actividades()}
            {this.avances()}
          </Panel>
        </div>
      </Page>
    )
  }
}

const styles = {
  root: {
    flex: 1,
    padding: 25,
    display: 'flex',
    flexDirection: 'column',
  },

  panel: {
    flex: 1,
    padding: 0,
    display: 'flex',
  },

  seccion: {
    root: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
    },

    wrapper: {
      position: 'relative',
      flex: 1,
    },

    content: {
      position: 'absolute',
      overflowY: 'auto',
      left: 0,
      top: 0,
      bottom: 0,
    }
  },

  captura: {
    root: {
      position: 'relative',
      flex: 1,
    },

    content: {
      position: 'absolute',
      overflowY: 'auto',
      left: 0,
      top: 0,
      bottom: 0,
      paddingTop: 100,
    }
  },

  sections: {
    header: {
      padding: 15,
    },
  },


  actividad: {
    normal: {
      borderLeftStyle: 'solid',
      borderLeftWidth: 2,
    },
  },

  avances: {
    root: {
      display: 'flex',
      padding: 5,
    }
  },
}

export default connect(
  state => ({ theme: state.theme.values })
)(AvancesPage)
